/* Step 13 · P1 (lane S13A, N1 + D1) — EN + AR of the Audit Trail row the platform writes when it replaces a provider name in
   engagement text with a neutral word (Founder → Maintenance J, provider_names_fix_v1), and of the AI log as an entity of that row.
   No provider name and no standard paragraph is quoted. */
const I18N_S13P1 = {
  en: {
    w13: {
      action: {
        provider_name_replaced: "Provider name replaced with a neutral word",
      },
      entity: {
        ai_log: "AI log",
      },
    },
  },
  ar: {
    w13: {
      action: {
        provider_name_replaced: "استُبدل اسم المزوّد بكلمة محايدة",
      },
      entity: {
        ai_log: "سجل الذكاء الاصطناعي",
      },
    },
  },
};

export default I18N_S13P1;
